<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" md="11" mx-auto>
        <v-card flat>
          <v-card-title class="px-0 py-2">
            <v-combobox
            v-model="curComm"
            label="Community"
            :items="commList"
            item-text="comm_name"
            item-value="comm_id"
            placeholder="Choose"
            @input="curComm ? loadFacconfigBasedOnComm(curComm) : ''"
            filled
            clearable
            ></v-combobox>
          </v-card-title>
          <v-card-text class="pa-0" v-if="curComm && curComm.comm_id">
            <v-layout row wrap>
              <v-flex xs12>
                <!-- Blocks -->
                <v-card>
                  <v-card-title class="pa-2 title primary--text grey lighten-4">
                    <span>Blocks</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="prepareCreateBlock"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text class="pa-0">
                    <v-data-table
                    :headers="facSet"
                    :items="blockList"
                    hide-default-footer
                    disable-pagination
                    sort-by="block_nm"
                    :mobile-breakpoint="0">
                    <template slot="item" slot-scope="props">
                      <tr @click="prepareEditBlock(props.item)">
                        <td>{{ props.item.block_nm ? props.item.block_nm : '-' }}</td>
                        <td>{{ props.item.floors ? props.item.floors : '-' }}</td>
                        <td>{{ props.item.flats ? props.item.flats : '-' }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <!-- Applicable Water Types -->
              <v-card>
                <v-card-title class="pa-2 title primary--text grey lighten-4">
                  <div>Applicable Water Types</div>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="prepareCreateWaterType"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="watType"
                  :items="typeList"
                  hide-default-footer
                  disable-pagination
                  sort-by="water_type"
                  :mobile-breakpoint="0">
                  <template slot="item" slot-scope="props">
                    <tr @click="prepareEditWaterType(props.item)">
                      <td>{{ props.item.water_type }}</td>
                      <td><v-icon :color="props.item.is_source ? 'green' : 'red'">{{ props.item.is_source ? 'mdi-check' : 'mdi-close' }}</v-icon></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <!-- Water Quality Parameter -->
            <v-card>
              <v-card-title class="pa-2 title primary--text grey lighten-4">
                <div>Water Quality Param</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="prepareCreateWaterQual"><v-icon>mdi-playlist-plus</v-icon></v-btn>
              </v-card-title>
              <v-card-text class="pa-0">
                <v-data-table
                class="tblWaterQual"
                :headers="$vuetify.breakpoint.smAndUp?watQual:watQualsm"
                :items="qualList"
                hide-default-footer
                disable-pagination
                disable-sort
                :mobile-breakpoint="0">
                <template slot="item" slot-scope="props">
                  <tr @click="prepareEditWaterQual(props.item)">
                    <td @click="dragElement(qualList[0].comm_id)" class="handle"><v-icon small>mdi-arrow-expand-all</v-icon></td>
                    <td>{{ props.item.water_type ? props.item.water_type : '-' }}</td>
                    <td>{{ props.item.param_name ? props.item.param_name : '-' }}</td>
                    <td>{{ props.item.uom ? props.item.uom : '-' }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.std_val_min ? props.item.std_val_min : 0 }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.std_val_max ? props.item.std_val_max : 0 }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <!-- Water Storage -->
          <v-card>
            <v-card-title class="pa-2 title primary--text grey lighten-4">
              <div>Water Storage</div>
              <v-spacer></v-spacer>
              <v-btn icon @click="prepareCreateStorage"><v-icon>mdi-playlist-plus</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-0">
              <v-data-table
              :headers="$vuetify.breakpoint.smAndUp?waterStorage:waterStorageSm"
              :items="storageList"
              disable-initial-sort
              hide-default-footer
              disable-pagination
              sort-by="storage_nm"
              :mobile-breakpoint="0">
              <template slot="item" slot-scope="props">
                <tr @click="prepareEditStorage(props.item)">
                  <td>{{ props.item.storage_nm ? props.item.storage_nm : '-' }}</td>
                  <td>{{ props.item.water_cat }}</td>
                  <td>{{ props.item.storage_cap ? props.item.storage_cap : '-' }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp">
                    <v-icon color="green" v-if="props.item.is_level_checked">mdi-check</v-icon>
                    <v-icon color="red" v-else>mdi-close</v-icon>
                  </td>
                  <!-- <td v-if="$vuetify.breakpoint.smAndUp">
                  <v-icon color="green" v-if="props.item.is_receipt_checked">mdi-check</v-icon>
                  <v-icon color="red" v-else>mdi-close</v-icon>
                </td> -->
                <td v-if="$vuetify.breakpoint.smAndUp">
                  <v-icon color="green" v-if="props.item.is_cons_checked">mdi-check</v-icon>
                  <v-icon color="red" v-else>mdi-close</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <!-- Power Meters -->
      <v-card>
        <v-card-title class="pa-2 title primary--text grey lighten-4">
          <div>Power Meters</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="prepareCreateMeter"><v-icon>mdi-playlist-plus</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
          :headers="powerMeter"
          :items="meterList.filter(rec => rec.meter_nm !== '')"
          hide-default-footer
          disable-pagination
          sort-by="meter_nm"
          :mobile-breakpoint="0">
          <template slot="item" slot-scope="props">
            <tr @click="prepareEditMeter(props.item)">
              <td>{{ props.item.meter_nm ? props.item.meter_nm : '-' }}</td>
              <td>{{ props.item.meter_location ? props.item.meter_location : '-' }}</td>
              <td>{{ props.item.area_covered ? props.item.area_covered : '-' }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>
  <v-flex xs12>
    <!-- Gensets -->
    <v-card>
      <v-card-title class="pa-2 title primary--text grey lighten-4">
        <div>Gensets</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="prepareCreateGensets"><v-icon>mdi-playlist-plus</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-data-table
        :headers="$vuetify.breakpoint.smAndUp?genSets:genSetsSm"
        :items="gensetList.filter(rec => rec.genset_nm !== '')"
        hide-default-footer
        disable-pagination
        sort-by="genset_nm"
        :mobile-breakpoint="0">
        <template slot="item" slot-scope="props">
          <tr @click="prepareEditGensets(props.item)">
            <td>{{ props.item.genset_nm ? props.item.genset_nm : '-' }}</td>
            <td>{{ props.item.genset_rating ? props.item.genset_rating : '-' }}</td>
            <td>{{ props.item.genset_cap }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</v-flex>
<v-flex xs12>
  <!-- Sanity Checks -->
  <v-card>
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title primary--text grey lighten-4">Sanity Checks</div>
      <v-spacer></v-spacer>
      <v-btn icon @click="prepareCreateSanCheck"><v-icon>mdi-playlist-plus</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="hygHead"
      :items="sanCheckList"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0"
      >
      <template slot="item" slot-scope="props">
        <tr @click="prepareEditSanCheck(props.item)">
          <td>{{ props.item.check_cat ? props.item.check_cat : '-' }}</td>
          <td>{{ props.item.check_desc ? props.item.check_desc : '-' }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-flex>
<v-flex xs12>
  <!-- Other Custom Metrics -->
  <v-card>
    <v-card-title class="pa-2 title primary--text grey lighten-4">
      <div>Other Custom Metrics</div>
      <v-spacer></v-spacer>
      <v-btn icon @click="prepareCreateCusMet"><v-icon>mdi-playlist-plus</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="cusMet"
      :items="metricList"
      hide-default-footer
      disable-pagination
      :sort-by="['metric_cat','metric_nm']"
      multi-sort
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr @click="prepareEditCusMet(props.item)">
          <td>{{ props.item.metric_cat ? props.item.metric_cat : '-' }}</td>
          <td>{{ props.item.metric_nm ? props.item.metric_nm : '-' }}</td>
          <td>{{ props.item.period_display? props.item.period_display: '-' }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-flex>

<v-flex xs12>
  <!-- Daily Update Photo Categories-->
  <v-card>
    <v-card-title class="pa-2 title primary--text grey lighten-4">
      <div>Daily Update Photo Categories</div>
      <v-spacer></v-spacer>
      <v-btn icon @click="prepareCreatePhotoCat"><v-icon>mdi-playlist-plus</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="photoCatHeader"
      :items="photoCat"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0"
      >
      <template slot="item" slot-scope="props">
        <tr @click="prepareEditPhotoCat(props.item)">
          <td>{{ props.item.attach_cat_name }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-flex>

<!-- Daily report for notifications -->
<v-flex xs12>
  <v-card>
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title grey--text">Notifications for Daily Report</div>
    </v-card-title>
    <v-card-text class="pa-2">
      <v-text-field
      v-model="lReport.email_list"
      label="Mail ids"
      hide-details
      maxlength="200"
      placeholder="Notification mail ids(comma seperated)"
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="accent" @click="saveDailyReportMailIds(lReport.email_list)">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-flex>

<v-flex xs12>
  <!-- Smartility IoT Devices -->
  <v-card>
    <v-card-title class="pa-2 title primary--text grey lighten-4">
      <div>Smartility IoT Devices</div>
      <v-spacer></v-spacer>
      <v-btn icon @click="prepareCreateSmartDevice"><v-icon>mdi-playlist-plus</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="smartDev"
      :items="deviceList"
      hide-default-footer
      disable-pagination
      :sort-by="['smart_dev_type','smart_dev_sno']"
      multi-sort
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr @click="prepareEditSmartDevice(props.item)">
          <td>{{ props.item.smart_dev_type ? props.item.smart_dev_type : '-' }}</td>
          <td>{{ props.item.smart_dev_sno ? props.item.smart_dev_sno : '-' }}</td>
          <td>{{ props.item.smart_dev_loc ? props.item.smart_dev_loc : '-' }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-flex>
</v-layout>
</v-card-text>
</v-card>

<!--Creating and updating the Blocks-->
<v-dialog v-model="showBlock" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveChanges(lBlock.action)">
        <v-card scrollable>
          <v-card-title class="title grey lighten-4">
            {{ lBlock.action }} Block
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lBlock.block_nm"
                label="Block Name"
                :rules="[rules.required]"
                hide-details
                maxlength="25"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lBlock.floors"
                label="Floors"
                hide-details
                type="number"
                maxlength="11"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lBlock.flats"
                label="Flats"
                hide-details
                type="number"
                maxlength="11"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn v-if="lBlock.action === 'Update'" @click="deleteBlock(lBlock)">delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click.stop="showBlock = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Water Types-->
<v-dialog v-model="showWaterType" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveWaterTypeChanges(lWaterType.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lWaterType.action }}  Water Type
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                v-model="lWaterType.water_type"
                :items="masterTypeList"
                label="Water Type"
                hide-details
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-checkbox v-model="lWaterType.is_source"
                label="Source of water to this community"
                hide-details
                >
              </v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-btn v-if="lWaterType.action === 'Update'" @click="deleteWaterType(lWaterType)">delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click.stop="showWaterType = false">Cancel</v-btn>
          <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</v-container>
</v-dialog>

<!--Creating and updating the Water Quality-->
<v-dialog v-model="showWaterQuality" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveWatQualChanges(lWaterQual.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lWaterQual.action }} Water Quality
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                v-model="lWaterQual.water_type_pair"
                label="Water Type"
                :items="typeList"
                item-text="water_type"
                return-object
                :rules="[rules.required]"
                hide-details
                @input="loadWaterQualityReference(lWaterQual.water_type_id)"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-combobox
                v-model="lWaterQual.param_name"
                label="Parameter Name"
                :items="paramList.map(rec => rec.param_name)"
                hide-details
                @input="loadBasedParamName(lWaterQual.param_name, lWaterQual.water_type_id)"
                ></v-combobox>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lWaterQual.uom"
                label="UoM"
                hide-details
                maxlength="10"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lWaterQual.std_val_min"
                label="Min"
                hide-details
                type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lWaterQual.std_val_max"
                label="Max"
                hide-details
                type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn v-if="lWaterQual.action ==='Update'" @click="deleteQual(lWaterQual)">delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click.stop="showWaterQuality = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Water Storage-->
<v-dialog v-model="showWaterStorage" persistent max-width="600px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveStorageChanges(lStorage.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lStorage.action }} Water Storage
          </v-card-title>
          <v-card-text class="pt-2">
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                v-model="lStorage.storage_nm"
                label="Water Storage Name"
                :rules="[rules.required]"
                hide-details
                maxlength="25"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lStorage.storage_cap"
                label="Water Storage Capacity"
                hide-details
                type="number"
                maxlength="11"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                v-model="lStorage.water_cat"
                :items="['Domestic', 'Recycled/Treated']"
                label="Category"
                :rules="[rules.required]"
                hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-checkbox
                    v-model="lStorage.is_level_checked"
                    label="Is Level Checked?" hide-details class="mt-2"
                    ></v-checkbox>
                  </v-flex>
                  <!-- <v-flex xs4>
                  <v-checkbox
                  v-model="lStorage.is_receipt_checked"
                  label="Is Receipt Checked?" hide-details class="mt-2"
                  ></v-checkbox>
                </v-flex> -->
                <v-flex xs12 sm6>
                  <v-checkbox
                  v-model="lStorage.is_cons_checked"
                  label="Is Cons Checked?" hide-details class="mt-2"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 class="pt-3 pb-0">
              <span class="primary--text subheader pa-0">Real Time Monitoring</span>
            </v-flex>
            <v-flex xs12 class="pt-0">
              <v-layout row wrap>
                <v-flex xs6>
                  <v-select
                  v-model="lStorage.rtm_provider"
                  :items="['Waltr', 'Waterize']"
                  placeholder="No RTM Installed"
                  clearable
                  hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lStorage.rtm_integrate_id_1"
                  :label="lStorage.rtm_provider ? lStorage.rtm_provider + ' Tank Id' : ''"
                  :rules="lStorage.rtm_provider ? [rules.required] : []"
                  type="number"
                  hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 class="pt-3 pb-0">
              <span class="primary--text subheader pa-0">Water Level Alert</span>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                  v-model="lStorage.min_level"
                  label="Min Water Level (%)"
                  type="number"
                  hide-details
                  :disabled="lStorage.is_level_checked ? false : true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lStorage.max_level"
                  label="Max Water Level (%)"
                  type="number"
                  hide-details
                  :disabled="lStorage.is_level_checked ? false : true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="px-4 pb-4 pt-0">
          <v-btn v-if="lStorage.action ==='Update'" @click="deleteStorage(lStorage)">delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click.stop="showWaterStorage = false">Cancel</v-btn>
          <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</v-container>
</v-dialog>

<!--Creating and updating the Power Meter-->
<v-dialog v-model="showPowerMeter" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveMeterChanges(lPowerMeter.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lPowerMeter.action }} Power Meter
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lPowerMeter.meter_nm"
                label="Meter Name"
                :rules="[rules.required]"
                hide-details
                maxlength="25"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lPowerMeter.meter_location"
                label="Meter Location"
                hide-details
                maxlength="25"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lPowerMeter.area_covered"
                label="Area Covered"
                :rules="[rules.required]"
                hide-details
                maxlength="15"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn v-if="lPowerMeter.action === 'Update'" @click="deleteMeter(lPowerMeter)">delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click.stop="showPowerMeter = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Genset-->
<v-dialog v-model="showGenset" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveGenChanges(lGen.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lGen.action }} Genset
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lGen.genset_nm"
                label="Genset Name"
                :rules="[rules.required]"
                hide-details
                maxlength="15"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lGen.genset_rating"
                label="Genset Rating"
                hide-details
                maxlength="15"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lGen.genset_cap"
                label="Genset Capacity (ltr)"
                hide-details
                maxlength="15"
                type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn v-if=" lGen.action === 'Update'" @click="deleteGen(lGen)">delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click.stop="showGenset = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Custom Metric-->
<v-dialog v-model="showCustomMetric" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveCustomMetChanges(lCusMet.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lCusMet.action }} Custom Metric
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-combobox
                v-model="lCusMet.metric_cat"
                label="Metric category"
                :items="metricList.map(rec => rec.metric_cat)"
                :rules="[rules.required]"
                hide-details
                maxlength="25"
                ></v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lCusMet.metric_nm"
                label="Metric Name"
                :rules="[rules.required]"
                hide-details
                maxlength="50"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                v-model="lCusMet.period_display"
                label="What to display when this metric is viewed for multiple days"
                :items="[{'value':'A', 'text':'Average'}, {'value':'T', text:'Total'}]"
                item-value="value"
                item-text="text"
                :rules="[rules.required]"
                hide-details
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn v-if="lCusMet.action === 'Update'" @click="deleteMet(lCusMet)">delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click.stop="showCustomMetric= false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the daily update photo categories-->
<v-dialog v-model="showPhotoCat" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="savePhotoCat(lPhotoCat.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lPhotoCat.action }} Photo Category
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lPhotoCat.attach_cat_name"
                label="Category Name"
                :rules="[rules.required]"
                hide-details
                maxlength="100"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn v-if="lPhotoCat.action === 'Update'" @click="deletePhotoCat(lPhotoCat)">delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click.stop="showPhotoCat = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Smartility IoT Devices-->
<v-dialog v-model="showIoTDevices" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveSmartDeviceChanges(lSmartDev.action)">
        <v-card flat>
          <v-card-title class="py-2 title grey lighten-4">
            {{ lSmartDev.action }} Smartility Device
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                v-model="lSmartDev.smart_dev_type"
                label="Type"
                :items="smartDevTypes"
                item-value="smart_dev_id"
                item-text="smart_dev_type"
                :rules="[rules.required]"
                hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lSmartDev.smart_dev_sno"
                label="Serial Number"
                hide-details
                type="number"
                maxlength="10"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lSmartDev.smart_dev_loc"
                label="Location"
                hide-details
                maxlength="10"
                ></v-text-field>
              </v-flex>
              <!-- device specific config -->
              <v-flex xs12 v-if="lSmartDev.smart_dev_type === 'FaceCheckin'">
                <v-layout row wrap>
                  <v-flex xs12 class="pb-0">
                    <div class="primary--text">Purpose</div>
                  </v-flex>
                  <v-flex xs12>
                    <v-radio-group
                    row class="ma-0" v-model="lSmartDev.fcDevPurpose"
                    hide-details
                    >
                    <v-radio
                    label="Time & Attendance"
                    value="T"
                    ></v-radio>
                    <v-radio
                    label="Others"
                    value="O"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <div class="primary--text">Mode</div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group
                  row class="ma-0" v-model="lSmartDev.fc_inout_mode"
                  hide-details
                  >
                  <v-radio
                  label="IN/OUT"
                  value="IN/OUT"
                  ></v-radio>
                  <v-radio
                  label="IN Only"
                  value="IN"
                  ></v-radio>
                  <v-radio
                  label="OUT Only"
                  value="OUT"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12>
                <div class="primary--text">Voice settings</div>
              </v-flex>
              <v-flex xs12 class="pt-0">
                <v-switch
                v-model="lSmartDev.fc_is_voice_enabled"
                label="Voice enabled"
                hide-details
                class="pt-0"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-switch
                v-model="lSmartDev.fc_is_name_read"
                label="Pronounce user name"
                hide-details
                class="pt-0"
                :disabled="!lSmartDev.fc_is_voice_enabled"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-select
                v-model="lSmartDev.fcLangList"
                label="Languages"
                :items="['eng', 'hi', 'kn', 'ms', 'ta']"
                chips
                multiple
                :disabled="!lSmartDev.fc_is_voice_enabled"
                hide-details
                >
              </v-select>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="pt-0">
      <v-btn v-if="lSmartDev.action === 'Update'" @click="deleteSmartDevice(lSmartDev)">delete</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click.stop="showIoTDevices = false">Cancel</v-btn>
      <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-form>
</v-flex>
</v-container>
</v-dialog>

<!--Creating and updating the Sanity checks-->
<v-dialog v-model="showSanChecks" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="hForm" @submit.prevent="saveSanCheckChanges(lSanCheck.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lSanCheck.action }} Sanity Check
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-combobox
                v-model="lSanCheck.check_cat"
                label="Category"
                :items="sanCheckList.map(rec => rec.check_cat)"
                :rules="[rules.required]"
                hide-details
                maxlength="50"
                ></v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lSanCheck.check_desc"
                label="Description"
                :rules="[rules.required]"
                hide-details
                maxlength="150"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn v-if="lSanCheck.action === 'Update'" @click="deleteSanCheck(lSanCheck)">delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click.stop="showSanChecks = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-col>
</v-row>
</v-container>
</template>

<style>
.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
</style>

<script>
import handy from '@/utils/handy'
import config from '@/config/app-cfg'
import Sortable from 'sortablejs'

export default {
  data () {
    return {
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      commList: [],
      curComm: '',
      facHead: [
        { text: 'Society ', value: 'comm_name' },
      ],
      lFacConfig: [],
      lBlock: [],
      blockList: [],
      facSet: [
        { text: 'Block', value: 'block_nm' },
        { text: 'Floors', value: 'floors' },
        { text: 'Flats', value: 'flats' }
      ],
      typeList: [],
      masterTypeList: [],
      paramList: [],
      lStorage: [],
      storageList: [],
      waterStorage: [
        { text: 'Tank Name', value: 'storage_nm' },
        { text: 'Category', value: 'water_cat' },
        { text: 'Tank Capacity (ltr)', value: 'storage_cap' },
        { text: 'Level Checked?', value: 'is_level_checked' },
        // { text: 'Receipt Checked?', value: 'is_receipt_checked' },
        { text: 'Cons Checked?', value: 'is_cons_checked' }
      ],
      waterStorageSm: [
        { text: 'Tank Name', value: 'storage_nm' },
        { text: 'Category', value: 'water_cat' },
        { text: 'Tank Capacity (ltr)', value: 'storage_cap' }
      ],
      lPowerMeter: [],
      meterList: [],
      powerMeter: [
        { text: 'Meter Name', value: 'meter_nm' },
        { text: 'Location', value: 'meter_location' },
        { text: 'Area Covered', value: 'area_covered' }
      ],
      lGen: [],
      gensetList: [],
      genSets: [
        { text: 'Name', value: 'genset_nm' },
        { text: 'Rating', value: 'genset_rating' },
        { text: 'Diesal Capacity (ltr)', value: 'genset_cap' }
      ],
      genSetsSm: [
        { text: 'Name', value: 'genset_nm' },
        { text: 'Rating', value: 'genset_rating' },
        { text: 'Diesal Cap (ltr)', value: 'genset_cap' }
      ],
      lCusMet: [],
      hygHead: [
        { text: 'Category', value: 'check_cat' },
        { text: 'Description', value: 'check_desc' }
      ],
      sanCheckList: [],
      lSanCheck: [],
      showSanChecks: false,
      metricList: [],
      cusMet: [
        { text: 'Metric Category', value: 'metric_cat' },
        { text: 'Metric Name', value: 'metric_nm' },
        { text: 'Total/Average', value: 'period_display' }
      ],
      deviceList: [],
      lSmartDev: [],
      smartDevTypes: [],
      smartDev: [
        { text: 'Type', value: 'smart_dev_type' },
        { text: 'Serial Number', value: 'smart_dev_sno' },
        { text: 'Location', value: 'smart_dev_loc' }
      ],
      typeList: [],
      lWaterType: [],
      watType: [
        { text: 'Water type', value: 'water_type' },
        { text: 'Is Source?', value: 'is_source' }
      ],
      qualList: [],
      lWaterQual: [],
      watQual: [
        { text: '', value: '' },
        { text: 'Water Type', value: 'water_type' },
        { text: 'Parameter Name', value: 'param_name' },
        { text: 'UoM', value: 'uom' },
        { text: 'Min', value: 'std_val_min' },
        { text: 'Max', value: 'std_val_max' }
      ],
      watQualsm: [
        { text: '', value: '' },
        { text: 'Water Type', value: 'water_type' },
        { text: 'Param Name', value: 'param_name' },
        { text: 'UoM', value: 'uom' }
      ],
      lPhotoCat: [],
      photoCat: [],
      photoCatHeader: [
        { text: 'Category Name', value: 'cat_name' }
      ],
      showBlock: false,
      showWaterType: false,
      showWaterQuality: false,
      showWaterStorage: false,
      showPowerMeter: false,
      showGenset: false,
      showCustomMetric: false,
      showIoTDevices: false,
      showPhotoCat: false,
      lCommName: '',
      lCommId: null,
      lReport: []
    }
  },
  mounted () {
    this.loadCommunityName()
  },
  methods: {
    dragElement (curCommId) {
      let table = document.querySelector('.tblWaterQual tbody')
      const self = this
      Sortable.create(table, {
        handle: '.handle',
        onEnd ({ newIndex, oldIndex }) {
          const rowSelected = self.qualList.splice(oldIndex, 1)[0]
          self.qualList.splice(newIndex, 0, rowSelected)
          self.qualList[newIndex].disp_order = newIndex
          self.qualList[newIndex].oldIndex = oldIndex
          self.qualList[newIndex].comm_id = curCommId
          self.saveWatQualIndex(self.qualList[newIndex])
        }
      })
    },
    saveWatQualIndex (curWatQualList) {
      this.axios.post(config.SMARTILITY_API_URL + '/waterquality/index', curWatQualList)
      .then(response => {
        this.loadWaterQuality(curWatQualList.comm_id)
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadCommunityName () {
      var qry = {
        params: {
          vendor_id : config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommunityByVendorId/' , qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadMasterWaterType () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getMasterWaterTypeByVendorId/', qry)
      .then(response => {
        this.masterTypeList = response.data.map(rec => rec.water_type)
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadWaterQualityReference (curWaterTypeId) {
      var qry = {
        params: {
          comm_id: this.lFacConfig.comm_id,
          water_type_id: curWaterTypeId
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterQualityReferenceByCommId/', qry)
      .then(response => {
        this.paramList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadSmartDevTypes () {
      this.axios.get(config.SMARTILITY_API_URL + '/getSmartDeviceTypes/')
      .then(response => {
        this.smartDevTypes = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadBasedParamName (curParamName, curWaterTypeId) {
      if (curParamName) {
        var tmpWaterQual = this.paramList.filter(rec => rec.param_name === curParamName)
        this.lWaterQual.std_val_min = tmpWaterQual[0].std_val_min ? tmpWaterQual[0].std_val_min : 0
        this.lWaterQual.std_val_max = tmpWaterQual[0].std_val_max
        this.lWaterQual.uom = tmpWaterQual[0].uom
        this.lWaterQual.param_name = tmpWaterQual[0].param_name
        this.lWaterQual.water_type_id = curWaterTypeId
      }
    },
    loadWaterQuality (curCommId) {
      var qry = {
        params: {
          comm_id: curCommId
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterQualityByCommId/', qry)
      .then(response => {
        this.qualList = response.data
        this.qualList[0].comm_id = curCommId
        this.dragElement(curCommId)
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadFacconfigBasedOnComm (curComm) {
      this.loadWaterQuality(curComm.comm_id)
      this.loadDailyReportMailIds(curComm.comm_id)
      this.lFacConfig = Object.assign({}, curComm)
      this.lCommName = curComm.comm_name
      this.lCommId = curComm.comm_id
      var qry = {
        params: {
          comm_id: this.lCommId
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getBlocksByCommId/', qry)
      .then(response => {
        this.blockList = response.data
      })
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterTypeByCommId/', qry)
      .then(response => {
        this.typeList = response.data
      })
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterStorageByCommId/', qry)
      .then(response => {
        this.storageList = response.data
      })
      this.axios.get(config.SMARTILITY_API_URL + '/getPowerMeterByCommId/', qry)
      .then(response => {
        this.meterList = response.data
      })
      this.axios.get(config.SMARTILITY_API_URL + '/getGenSetByCommId/', qry)
      .then(response => {
        this.gensetList = response.data
      })
      this.axios.get(config.SMARTILITY_API_URL + '/getCusMetByCommId/', qry)
      .then(response => {
        this.metricList = response.data
      })
      this.axios.get(config.SMARTILITY_API_URL + '/getSmartDeviceByCommId/', qry)
      .then(response => {
        this.deviceList = response.data
      })
      this.axios.get(config.SMARTILITY_API_URL + '/getPhotoCatByCommId/', qry)
      .then(response => {
        this.photoCat = response.data
      })
      this.axios.get(config.SMARTILITY_API_URL + '/getSanCheckListByCommId/', qry)
      .then(response => {
        this.sanCheckList = response.data
      })
    },
    prepareCreateBlock () {
      this.lBlock = {
        comm_id: this.lCommId,
        block_nm: '',
        floors: '',
        flats: ''
      }
      this.lBlock.action = 'Create'
      this.showBlock = true
    },
    prepareEditBlock (curBlock) {
      this.lBlock = Object.assign({}, curBlock)
      this.lBlock.action = 'Update'
      this.showBlock = true
    },
    saveChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        this.beingSaved = true
        this.lBlock.comm_id = this.lCommId
        this.lBlock.comm_name = this.lCommName
        this.axios.post(config.SMARTILITY_API_URL + '/facBlock/' + action, this.lBlock)
        .then(response => {
          if (action === 'Create') {
            this.lBlock.block_id = response.data
            this.blockList.push(this.lBlock)
          } else {
            this.idx = this.blockList.findIndex(rec => rec.block_id === this.lBlock.block_id)
            Object.assign(this.blockList[this.idx], this.lBlock)
          }
          this.beingSaved = false
          this.showBlock = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    deleteBlock (curBlock) {
      if (!confirm('Sure, you want to delete the Block "' + curBlock.block_nm + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.lBlock.comm_id = this.lCommId
      this.lBlock.comm_name = this.lCommName
      this.axios.post(config.SMARTILITY_API_URL + '/facBlock/delete', this.lBlock)
      .then(response => {
        this.idx = this.blockList.findIndex(rec => rec.block_id === this.lBlock.block_id)
        this.blockList.splice(this.idx, 1)
        this.beingSaved = false
        this.showBlock = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
        this.showBlock = false
      })
    },
    prepareCreateWaterType () {
      this.lWaterType = {
        comm_id: this.lCommId,
        water_type: ''
      }
      this.lWaterType.action = 'Create'
      this.loadMasterWaterType()
      this.showWaterType = true
    },
    saveWaterTypeChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        this.beingSaved = true
        this.lWaterType.comm_id = this.lCommId
        this.lWaterType.comm_name = this.lCommName
        this.axios.post(config.SMARTILITY_API_URL + '/watertype/' + action, this.lWaterType)
        .then(response => {
          if (action === 'Create') {
            this.loadFacconfigBasedOnComm(this.lWaterType)
          } else {
            this.idx = this.typeList.findIndex(rec => rec.water_type_id === this.lWaterType.water_type_id)
            Object.assign(this.typeList[this.idx], this.lWaterType)
          }
          this.beingSaved = false
          this.showWaterType = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditWaterType (curWatType) {
      this.lWaterType = Object.assign({}, curWatType) // keep the original object safely before changes
      this.loadMasterWaterType()
      this.lWaterType.action = 'Update'
      this.showWaterType = true
    },
    deleteWaterType (curWatType) {
      if (!confirm('Sure, you want to delete the water type with name "' + curWatType.water_type + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.lWaterType.comm_id = this.lCommId
      this.lWaterType.comm_name = this.lCommName
      this.axios.post(config.SMARTILITY_API_URL + '/watertype/delete', this.lWaterType)
      .then(response => {
        this.idx = this.typeList.findIndex(rec => rec.water_type_id === this.lWaterType.water_type_id)
        this.typeList.splice(this.idx, 1)
        this.loadFacconfigBasedOnComm(this.lWaterType)
        this.beingSaved = false
        this.showWaterType = false
      })
      .catch(err => {
        console.log(err)
        this.msg('Before deleting water types, delete the records from Water Quality', 0)
        this.beingSaved = false
      })
    },
    prepareCreateWaterQual () {
      this.lWaterQual = {
        water_type_pair: {},
        param_name: '',
        uom: '',
        std_val_min: null,
        std_val_max: null
      }
      this.lWaterQual.action = 'Create'
      this.showWaterQuality = true
    },
    saveWatQualChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        if (!this.lWaterQual.water_type_pair.water_type) {
        this.msg('Please select water type', 0)
        return
      }
        this.beingSaved = true
        this.lWaterQual.comm_id = this.lCommId
        this.lWaterQual.comm_name = this.lCommName
        this.lWaterQual.water_type = this.lWaterQual.water_type_pair.water_type
        this.lWaterQual.water_type_id = this.lWaterQual.water_type_pair.water_type_id
        this.axios.post(config.SMARTILITY_API_URL + '/waterquality/' + action, this.lWaterQual)
        .then(response => {
          if (action === 'Create') {
            this.lWaterQual.param_id = response.data
            this.qualList.push(this.lWaterQual)
          } else {
            this.idx = this.qualList.findIndex(rec => rec.param_id === this.lWaterQual.param_id)
            Object.assign(this.qualList[this.idx], this.lWaterQual)
          }
          this.beingSaved = false
          this.showWaterQuality = false
          this.$forceUpdate()
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditWaterQual (curWatQual) {
      this.lWaterQual = Object.assign({}, curWatQual) // keep the original object safely before changes
      this.lWaterQual.water_type_pair = { water_type_id: curWatQual.water_type_id, water_type: curWatQual.water_type }
      this.lWaterQual.action = 'Update'
      this.showWaterQuality = true
    },
    deleteQual (curWatQual) {
      if (!confirm('Sure, you want to delete the water quality param "' + curWatQual.water_type + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.lWaterQual.comm_id = this.lCommId
      this.lWaterQual.comm_name = this.lCommName
      this.axios.post(config.SMARTILITY_API_URL + '/waterquality/delete', this.lWaterQual)
      .then(response => {
        this.idx = this.qualList.findIndex(rec => rec.param_id === this.lWaterQual.param_id)
        this.qualList.splice(this.idx, 1)
        this.beingSaved = false
        this.showWaterQuality = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    prepareCreateStorage () {
      this.lStorage = {
        comm_id: this.lCommId,
        storage_nm: '',
        storage_cap: '',
        water_cat: '',
        is_level_checked: '',
        is_receipt_checked: '',
        is_cons_checked: '',
        rtm_provider: null,
        rtm_integrate_id_1: null,
        min_level: null,
        max_level: null,
        is_alarm_on: false
      }
      this.lStorage.action = 'Create'
      this.showWaterStorage = true
    },
    saveStorageChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        if (!this.lStorage.storage_nm) {
          this.msg('Please enter storage name', 0)
          return
        }

        this.lStorage.comm_id = this.lCommId
        this.lStorage.comm_name = this.lCommName
        this.lStorage.storage_cap = this.lStorage.storage_cap ? this.lStorage.storage_cap : null
        if (this.lStorage.min_level) {
          if (this.lStorage.min_level < 0 || this.lStorage.min_level > 100) {
            this.msg('Please add the value of min water level between 0-100 only', 0)
            return
          }
        }
        if (this.lStorage.max_level) {
          if (this.lStorage.max_level < 0 || this.lStorage.max_level > 100) {
            this.msg('Please add the value of max water level between 0-100 only', 0)
            return
          }
        }
        this.beingSaved = true
        this.axios.post(config.SMARTILITY_API_URL + '/waterStorage/' + action, this.lStorage)
        .then(response => {
          if (action === 'Create') {
            this.lStorage.storage_id = response.data
            this.storageList.push(this.lStorage)
          } else {
            this.idx = this.storageList.findIndex(rec => rec.storage_id === this.lStorage.storage_id)
            Object.assign(this.storageList[this.idx], this.lStorage)
          }
          this.beingSaved = false
          this.showWaterStorage = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    deleteStorage (curStorage) {
      if (!confirm('Sure, you want to delete the Water Storage "' + curStorage.storage_nm + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.lStorage.comm_id = this.lCommId
      this.lStorage.comm_name = this.lCommName
      this.axios.post(config.SMARTILITY_API_URL + '/waterStorage/delete', this.lStorage)
      .then(response => {
        this.idx = this.storageList.findIndex(rec => rec.storage_id === this.lStorage.storage_id)
        this.storageList.splice(this.idx, 1)
        this.beingSaved = false
        this.showWaterStorage = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    prepareEditStorage (curStorage) {
      this.lStorage = Object.assign({}, curStorage) // keep the original object safely before changes
      this.lStorage.action = 'Update'
      this.showWaterStorage = true
    },
    prepareCreateMeter () {
      this.lPowerMeter = {
        comm_id: this.lCommId,
        meter_nm: '',
        meter_location: '',
        area_covered: ''
      }
      this.lPowerMeter.action = 'Create'
      this.showPowerMeter = true
    },
    saveMeterChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        if (!this.lPowerMeter.area_covered) {
          this.msg('Please enter area covered section to reflect it in daily report', 0)
        } else {
          this.beingSaved = true
          this.lPowerMeter.comm_id = this.lCommId
          this.lPowerMeter.comm_name = this.lCommName
          this.axios.post(config.SMARTILITY_API_URL + '/powerMeter/' + action, this.lPowerMeter)
          .then(response => {
            if (action === 'Create') {
              this.lPowerMeter.meter_id = response.data
              this.meterList.push(this.lPowerMeter)
            } else {
              this.idx = this.meterList.findIndex(rec => rec.meter_id === this.lPowerMeter.meter_id)
              Object.assign(this.meterList[this.idx], this.lPowerMeter)
            }
            this.beingSaved = false
            this.showPowerMeter = false

          })
          .catch(err => {
            this.msg(err.response.data, 0)
            this.beingSaved = false
          })
        }
      }
    },
    prepareEditMeter (curMeter) {
      this.lPowerMeter = Object.assign({}, curMeter) // keep the original object safely before changes
      this.lPowerMeter.action = 'Update'
      this.showPowerMeter = true
    },
    deleteMeter (curMeter) {
      if (!confirm('Sure, you want to delete the Power Meter "' + curMeter.meter_nm + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.lPowerMeter.comm_id = this.lCommId
      this.lPowerMeter.comm_name = this.lCommName
      this.axios.post(config.SMARTILITY_API_URL + '/powerMeter/delete', this.lPowerMeter)
      .then(response => {
        this.idx = this.meterList.findIndex(rec => rec.meter_id === this.lPowerMeter.meter_id)
        this.meterList.splice(this.idx, 1)
        this.beingSaved = false
        this.showPowerMeter = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    prepareCreateGensets () {
      this.lGen = {
        comm_id: this.lCommId,
        genset_nm: '',
        genset_rating: '',
        genset_cap: ''
      }
      this.lGen.action = 'Create'
      this.showGenset = true
    },
    saveGenChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        this.beingSaved = true
        this.lGen.comm_id = this.lCommId
        this.lGen.comm_name = this.lCommName
        this.lGen.genset_cap = this.lGen.genset_cap ? this.lGen.genset_cap : null
        this.axios.post(config.SMARTILITY_API_URL + '/genset/' + action, this.lGen)
        .then(response => {
          if (action === 'Create') {
            this.lGen.genset_id = response.data
            this.gensetList.push(this.lGen)
          } else {
            this.idx = this.gensetList.findIndex(rec => rec.genset_id === this.lGen.genset_id)
            Object.assign(this.gensetList[this.idx], this.lGen)
          }
          this.beingSaved = false
          this.showGenset = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditGensets (curGen) {
      this.lGen = Object.assign({}, curGen) // keep the original object safely before changes
      this.lGen.action = 'Update'
      this.showGenset = true
    },
    deleteGen (curGen) {
      if (!confirm('Sure, you want to delete the Genset "' + curGen.genset_nm + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.lGen.comm_id = this.lCommId
      this.lGen.comm_name = this.lCommName
      this.axios.post(config.SMARTILITY_API_URL + '/genset/delete', this.lGen)
      .then(response => {
        this.idx = this.gensetList.findIndex(rec => rec.genset_id === this.lGen.genset_id)
        this.gensetList.splice(this.idx, 1)
        this.beingSaved = false
        this.showGenset = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    prepareCreateCusMet () {
      this.lCusMet = {
        comm_id: this.lCommId,
        metric_cat: '',
        metric_nm: '',
        period_display: 'T'
      }
      this.lCusMet.action = 'Create'
      this.showCustomMetric = true
    },
    saveCustomMetChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        this.beingSaved = true
        this.lCusMet.comm_id = this.lCommId
        this.lCusMet.comm_name = this.lCommName
        this.axios.post(config.SMARTILITY_API_URL + '/metric/' + action, this.lCusMet)
        .then(response => {
          if (action === 'Create') {
            this.lCusMet.metric_id = response.data
            this.metricList.push(this.lCusMet)
          } else {
            this.idx = this.metricList.findIndex(rec => rec.metric_id === this.lCusMet.metric_id)
            Object.assign(this.metricList[this.idx], this.lCusMet)
          }
          this.beingSaved = false
          this.showCustomMetric = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditCusMet (curMet) {
      this.lCusMet = Object.assign({}, curMet) // keep the original object safely before changes
      this.lCusMet.metric_cat_pair = { metric_cat: this.lCusMet.metric_cat, metric_id: this.lCusMet.metric_id }
      this.lCusMet.action = 'Update'
      this.showCustomMetric = true
    },
    deleteMet (curMet) {
      if (!confirm('Sure, you want to delete the Metric "' + curMet.metric_cat + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.lCusMet.comm_id = this.lCommId
      this.lCusMet.comm_name = this.lCommName
      this.axios.post(config.SMARTILITY_API_URL + '/metric/delete', this.lCusMet)
      .then(response => {
        this.idx = this.metricList.findIndex(rec => rec.metric_id === this.lCusMet.metric_id)
        this.metricList.splice(this.idx, 1)
        this.beingSaved = false
        this.showCustomMetric = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    prepareCreateSmartDevice () {
      this.lSmartDev = {
        comm_id: this.lCommId,
        smart_dev_type: '',
        smart_dev_sno: '',
        smart_dev_loc: '',
        // default for facecheckin device
        fcDevPurpose: 'T',
        fc_inout_mode: 'IN/OUT',
        fc_is_voice_enabled: true,
        fc_is_name_read: true,
        fcLangList: ['eng']
      }
      this.loadSmartDevTypes()
      this.lSmartDev.action = 'Create'
      this.showIoTDevices = true
    },
    saveSmartDeviceChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        this.beingSaved = true
        // pre-processing
        this.lSmartDev.fc_is_ta_dev = this.lSmartDev.fcDevPurpose === 'T'
        this.lSmartDev.fc_lang_code_list = this.lSmartDev.fcLangList.join(',')
        // for MS face
        this.lSmartDev.comm_id = this.lCommId
        this.lSmartDev.comm_name = this.lCommName
        this.lSmartDev.smart_dev_sno = this.lSmartDev.smart_dev_sno ? this.lSmartDev.smart_dev_sno : null
        this.axios.post(config.SMARTILITY_API_URL + '/smartdevice/' + action, this.lSmartDev)
        .then(response => {
          this.idx = -1
          if (action === 'Create') {
            this.lSmartDev.smart_dev_id = response.data
            this.deviceList.push(this.lSmartDev)
          } else {
            this.idx = this.deviceList.findIndex(rec => rec.smart_dev_id === this.lSmartDev.smart_dev_id)
            Object.assign(this.deviceList[this.idx], this.lSmartDev)
          }
          this.beingSaved = false
          this.showIoTDevices = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditSmartDevice (curDev) {
      this.lSmartDev = Object.assign({}, curDev) // keep the original object safely before changes
      this.lSmartDev.fcDevPurpose = this.lSmartDev.fc_is_ta_dev ? 'T' : 'O'
      this.lSmartDev.fcLangList = this.lSmartDev.fc_lang_code_list ? this.lSmartDev.fc_lang_code_list.split(',') : ''
      this.lSmartDev.old_smart_dev_type = this.lSmartDev.smart_dev_type
      this.lSmartDev.old_smart_dev_sno = this.lSmartDev.smart_dev_sno
      this.loadSmartDevTypes()
      this.lSmartDev.action = 'Update'
      this.showIoTDevices = true
    },
    deleteSmartDevice (curDev) {
      if (!confirm('Sure, you want to delete the Smartility Device with serial no. "' + curDev.smart_dev_sno + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.lSmartDev.comm_id = this.lCommId
      this.lSmartDev.comm_name = this.lCommName
      this.axios.post(config.SMARTILITY_API_URL + '/smartdevice/delete', this.lSmartDev)
      .then(response => {
        this.idx = this.deviceList.findIndex(rec => rec.smart_dev_id === this.lSmartDev.smart_dev_id)
        this.deviceList.splice(this.idx, 1)
        this.beingSaved = false
        this.showIoTDevices = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    prepareCreatePhotoCat () {
      this.lPhotoCat = {
        comm_id: this.lCommId,
        attach_cat_name: ''
      }
      this.lPhotoCat.action = 'Create'
      this.showPhotoCat = true
    },
    savePhotoCat (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        this.beingSaved = true
        this.lPhotoCat.comm_id = this.lCommId
        this.lPhotoCat.comm_name = this.lCommName
        this.axios.post(config.SMARTILITY_API_URL + '/photoCat/' + action, this.lPhotoCat)
        .then(response => {
          if (action === 'Create') {
            this.lPhotoCat.attach_cat_id = response.data
            this.photoCat.push(this.lPhotoCat)
          } else {
            this.idx = this.photoCat.findIndex(rec => rec.attach_cat_id === this.lPhotoCat.attach_cat_id)
            Object.assign(this.photoCat[this.idx], this.lPhotoCat)
          }
          this.beingSaved = false
          this.showPhotoCat = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditPhotoCat (curPhotoCat) {
      this.lPhotoCat = Object.assign({}, curPhotoCat) // keep the original object safely before changes
      this.lPhotoCat.action = 'Update'
      this.showPhotoCat = true
    },
    deletePhotoCat (curPhotoCat) {
      if (!confirm('Sure, you want to delete the photo category with name "' + curPhotoCat.attach_cat_name + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.SMARTILITY_API_URL + '/photoCat/delete', this.lPhotoCat)
      .then(response => {
        this.idx = this.photoCat.findIndex(rec => rec.attach_cat_id === this.lPhotoCat.attach_cat_id)
        this.photoCat.splice(this.idx, 1)
        this.beingSaved = false
        this.showPhotoCat = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    prepareCreateSanCheck () {
      this.lSanCheck = {
        check_desc: '',
        check_cat: '',
        comm_id: this.lCommId
      }
      this.lSanCheck.action = 'Create'
      this.showSanChecks = true
    },
    saveSanCheckChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.hForm.validate()) {
          return
        }
        this.beingSaved = true
        this.axios.post(config.SMARTILITY_API_URL + '/sanCheck/' + action, this.lSanCheck)
        .then(response => {
          if (action === 'Create') {
            this.lSanCheck.check_id = response.data
            this.sanCheckList.push(this.lSanCheck)
          } else {
            this.idx = this.sanCheckList.findIndex(rec => rec.check_id === this.lSanCheck.check_id)
            Object.assign(this.sanCheckList[this.idx], this.lSanCheck)
          }
          this.beingSaved = false
          this.showSanChecks = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditSanCheck (curSanCheck) {
      this.lSanCheck = Object.assign({}, curSanCheck) // keep the original object safely before changes
      this.lSanCheck.action = 'Update'
      this.showSanChecks = true
    },
    deleteSanCheck (curSanCheck) {
      if (!confirm('Sure, you want to delete the category "' + curSanCheck.check_desc + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.SMARTILITY_API_URL + '/sanCheck/delete', curSanCheck)
      .then(response => {
        this.idx = this.sanCheckList.findIndex(rec => rec.check_id === curSanCheck.check_id)
        this.sanCheckList.splice(this.idx, 1)
        this.beingSaved = false
        this.showSanChecks = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    saveDailyReportMailIds (curMailList) {
      // update the db
      this.lReport = {
        comm_id: this.lCommId,
        email_list: curMailList
      }
      if (!this.lReport.email_list) {
      this.msg('Please enter mail id', 0)
      return
    }
      this.axios.post(config.SMARTILITY_API_URL + '/dailyReportMailIds/', this.lReport)
      .then(response => {
        this.msg('Saved Successfully', 1)
        this.loadDailyReportMailIds(this.lCommId)
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadDailyReportMailIds (curCommId) {
      var qry = {
        params: {
          comm_id: curCommId
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getDailyReportMailIdsByCommId/', qry)
      .then(response => {
        if (response.data.length) {
          this.lReport.email_list = response.data[0].email_list
          this.lReport.comm_id = response.data[0].comm_id
        } else {
          this.lReport.email_list = ''
          this.lReport.comm_id = this.lCommId
        }
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.lReport = []
      })
    }
  }
}
</script>
